import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { HTTPService } from '../../services/httpService';

const API = new HTTPService();

// US State abbreviations for license plate dropdown
const US_STATES = [
  'AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA',
  'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD',
  'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ',
  'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC',
  'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY', 'DC'
];

class CarFaxDataModal extends Component {
  constructor(props) {
    super(props);

    // Pre-fill from any existing data, default plate state to company's state
    const defaultState = props.company?.installer_state?.toUpperCase() || '';

    // Parse existing plate if in "STATE-NUMBER" format
    let existingPlateState = '';
    let existingPlateNumber = '';
    if (props.existingPlate) {
      const parts = props.existingPlate.split('-');
      existingPlateState = parts[0] || '';
      existingPlateNumber = parts.slice(1).join('-') || '';
    }

    this.state = {
      odometerReading: props.existingOdometer || '',
      plateState: existingPlateState || defaultState,
      plateNumber: existingPlateNumber,
      saving: false,
      error: null
    };
  }

  handleSave = async () => {
    const { odometerReading, plateState } = this.state;

    if (!odometerReading || String(odometerReading).trim() === '') {
      this.setState({ error: 'Odometer reading is required.' });
      return;
    }

    if (!plateState) {
      this.setState({ error: 'License plate state is required.' });
      return;
    }

    this.setState({ saving: true, error: null });

    // Build plate string
    const plateNumber = this.state.plateNumber?.trim();
    const fullPlate = plateNumber
      ? `${plateState}-${plateNumber}`
      : plateState;

    try {
      await API.patch(`/requests/${this.props.requestId}/checkin/data`, {
        odometer_reading: odometerReading,
        license_plate: fullPlate,
        plate_state: plateState
      });

      this.props.onComplete(odometerReading, fullPlate);
    } catch (error) {
      console.error('Error saving CarFax data:', error);
      this.setState({
        saving: false,
        error: 'Failed to save. Please try again.'
      });
    }
  };

  render() {
    const { show, request } = this.props;
    const { odometerReading, plateState, plateNumber, saving, error } = this.state;

    return (
      <Modal show={show} onHide={() => {}} size="md" centered backdrop="static">
        <Modal.Header>
          <Modal.Title>
            <i className="fa-sharp fa-regular fa-tachometer mr-2"></i>
            CarFax Data Required
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {request && (
            <div className="alert alert-info mb-3">
              <i className="fa-sharp fa-regular fa-car mr-2"></i>
              <strong>{request.vehicleYear} {request.vehicleMake} {request.vehicleModel}</strong>
            </div>
          )}

          <p className="text-muted mb-3">
            Odometer reading and plate state are needed for CarFax reporting before completing this job.
          </p>

          {error && (
            <div className="alert alert-danger" role="alert">
              <i className="fa-sharp fa-regular fa-exclamation-triangle mr-2"></i>
              {error}
            </div>
          )}

          <div className="form-group">
            <label htmlFor="carfax-odometer" className="font-weight-bold">
              Odometer Reading <span className="text-danger">*</span>
            </label>
            <input
              id="carfax-odometer"
              type="number"
              className="form-control"
              value={odometerReading}
              onChange={(e) => this.setState({ odometerReading: e.target.value })}
              placeholder="e.g., 45230"
              disabled={saving}
            />
          </div>

          <div className="row">
            <div className="col-5">
              <div className="form-group">
                <label htmlFor="carfax-plateState" className="font-weight-bold">
                  Plate State <span className="text-danger">*</span>
                </label>
                <select
                  id="carfax-plateState"
                  className="form-control"
                  value={plateState}
                  onChange={(e) => this.setState({ plateState: e.target.value })}
                  disabled={saving}
                >
                  <option value="">Select</option>
                  {US_STATES.map(state => (
                    <option key={state} value={state}>{state}</option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-7">
              <div className="form-group">
                <label htmlFor="carfax-plateNumber" className="font-weight-bold">
                  Plate Number <span className="text-muted font-weight-normal">(optional)</span>
                </label>
                <input
                  id="carfax-plateNumber"
                  type="text"
                  className="form-control"
                  value={plateNumber}
                  onChange={(e) => this.setState({ plateNumber: e.target.value.toUpperCase() })}
                  placeholder="e.g., ABC1234"
                  disabled={saving}
                  maxLength={10}
                  style={{ textTransform: 'uppercase' }}
                />
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={this.handleSave}
            disabled={saving}
          >
            {saving ? (
              <>
                <i className="fa-sharp fa-regular fa-spinner fa-spin mr-2"></i>
                Saving...
              </>
            ) : (
              <>
                <i className="fa-sharp fa-regular fa-check mr-2"></i>
                Save & Continue
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default CarFaxDataModal;
